import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { labelids } from "../../assets/data/TkExplanationProperty";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者（法人）名",
    keyword: "contractorName",
    type: "text",
    showLine: false,
  },
  {
    title: "配置換え職員氏名",
    keyword: "staffName",
    type: "nodeInLine",
    helpicon: true,
    helpText: labelids.labelid.LBLC060104_02,
  },
  {
    title: "配置換え元の施設名",
    keyword: "bFacilityName",
    type: "text",
    helpicon: true,
    helpText: labelids.labelid.LBLC060104_03,
  },
  {
    title: "配置換え先の施設名",
    keyword: "aFacilityName",
    type: "selectForm",
    helpicon: true,
    helpText: labelids.labelid.LBLC060104_04,
  },
  {
    title: "配置換え先施設の配属日",
    keyword: "commutationDate",
    type: "date",
    helpicon: true,
    helpText: (
      <>
        {labelids.labelid.LBLC060104_05?.split("\\n")?.map?.(text => <>{text}<br/></>)}
      </>
    ),
    minDate: new Date("1900/1/1"),
    maxDate: new Date("2099/12/31"),
  },
];

const schema = {
  aFacilityName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  commutationDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};

const stepper = ["職員選択/配置換え入力", "配置換え確認", "登録完了"];
export { fakeTableList, schema, stepper };
